import Vue from 'vue';
import Vuex, { ActionContext, StoreOptions } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as Cookies from 'js-cookie';
import {
  RootState,
} from '@/utils/types/store';

import textModule from '@/store/text';
import documentRepoModule from '@/store/documentRepo';
import uiModule from '@/store/ui';
import documentComponentsModule from '@/store/documentComponents';

Vue.use(Vuex);

type Ctx = ActionContext<RootState, RootState>;

const store: StoreOptions<RootState> = {
  plugins: [
    // https://stackoverflow.com/questions/43027499/vuex-state-on-page-refresh
    createPersistedState({
      storage: {
        getItem: (key) => Cookies.get(key),
        setItem: (key, value) => Cookies
          .set(key, value, { expires: 3 }),
        removeItem: (key) => Cookies.remove(key),
      },
    }),
  ],
  modules: {
    text: textModule,
    documentRepo: documentRepoModule,
    documentComponents: documentComponentsModule,
    ui: uiModule,
  },
};

export default new Vuex.Store<RootState>(store);
